<template>
	<div class="page-content-wrapper">
		<div class="container-fluid" style="max-width:90%">
			<div class="row">
				<detalleCurso v-if="jsonCoordinadora" />
				<!-- end col -->
				<div class="col-xl-8">
					<titulosCurso />
					<tablaAlumnos />
				</div>
			</div>
			<!-- end row -->
		</div>
		<!-- end container-fluid -->
	</div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import XLSX from "xlsx";
import detalleCurso from "@/components/index/detalleCurso";
import titulosCurso from "@/components/index/titulosCurso";
import tablaAlumnos from "@/components/index/tablaAlumnos";

export default {
	components: {
		detalleCurso,
		titulosCurso,
		tablaAlumnos,
	},
	data: () => ({}),
	computed: {
		...mapState("alumno", ["jsonCoordinadora"]),
		...mapState("curso", ["jsonCurso"]),
		...mapState('curso',['titulosCurso']),
		...mapState("curso", ["currentSelector"]),
		...mapState("curso",["campusSeleccionadoMulti"]),
		...mapState('campus',['dataCampus']),
	},
	methods: {
		...mapActions("menu", ["updateMenu"]),
		...mapActions("menu", ["updateTitulo"]),
		...mapActions("alumno", ["updateJsonCoordinadora"]),
		...mapActions("curso", ["updateOnlyCurso"]),
		...mapActions("curso", ["updateTitulosCurso"]),
		...mapActions("curso", ["updateUltimosCursos"]),
		...mapActions("campus", ["addCampus"]),
		...mapActions("curso", ["setCurrentSelector"]),
		...mapActions("curso",["filterCursosByCampusAction"]),
		async getInfoLogeado() {
			const { data } = await this.axios.get("api/getLoginLogeado");
			const { usuarioDB: user } = data;
			const { data: dataCoordinadora } = await this.axios.get(`api/getCoordinadoraCampus`);

			let encoded = window.btoa(JSON.stringify(data.usuarioDB));
			localStorage.setItem("usuarioDB",encoded);

			this.updateJsonCoordinadora({ ...user,privilegios:dataCoordinadora.getPrivilegios });
		},
		async getCursosCoordinadora() {
			const { data } = await this.axios.get("api/getCursoCoordinadora");
			// console.log(data);
			const { getUltimosCurso: cursosUltimos } = data;
			const { listadoCursos, totalCursos, totalCampus,listadoCursosArchivados, listadoCampus} = data;


			//carga variables
			this.ultimosCursos = listadoCursos;
			let cursosDisponibles = [];  
			let cursosArchivados = [];  
			
			listadoCursos.map((curso) => {
				if(curso.archivado == 0){
					cursosDisponibles.push({
						idCurso: curso.idCurso,
						curso: curso.tituloCurso,
						campus: curso.tituloCampus,
						fechaInicio: curso.fechaInicio,
						cantidadAlumnos: curso.cantidadAlumnos
					});
				}else if(curso.archivado == 1){
	                cursosArchivados.push({
						idCurso: curso.idCurso,
						curso: curso.tituloCurso,
						campus: curso.tituloCampus,
						fechaInicio: curso.fechaInicio,
						cantidadAlumnos: curso.cantidadAlumnos
					});
				}
			});

			const titulosCurso = {
				listadoCursos:listadoCursos,
				totalAlumnos: listadoCursos.reduce((a, b) => a + b.cantidadAlumnos,0),
				totalCursos,
				cursosArchivados,
				cursosDisponibles,
				largoActualDisponibles:cursosDisponibles.length,
				largoActualArchivados:cursosArchivados.length,
				totalCampus
			};
			//vuex
			//aplicar el filtro de campus via localStorage o vuex si existe
			if(this.campusSeleccionadoMulti.titulo != undefined){
				//crear metodo en vuex que haga el filtro via un parametro idCampus o Nombre Campus
				this.filterCursosByCampusAction({
					campusSeleccionado:this.campusSeleccionadoMulti,
					titulosCurso:titulosCurso,
					filter:true
				});
			}else{
				this.updateOnlyCurso(cursosDisponibles);
				this.updateTitulosCurso(titulosCurso);
			}
			//guardar en el localStorage el listado de campus y eliminarlo al cerrar sesion
			localStorage.setItem("listadoCampusDisponibles",JSON.stringify(listadoCampus));
			this.addCampus(listadoCampus);
			this.updateUltimosCursos(cursosUltimos);
		},
		fechaConversion(fechaCurso) {
			var objDate = new Date(fechaCurso);
			let dia = objDate.toLocaleDateString("es-ES", { day: "numeric" }),
				mes = objDate.toLocaleDateString("es-ES", { month: "long" }),
				año = objDate.toLocaleDateString("es-ES", { year: "numeric" });

			return dia + " " + mes + " " + año;
		},
	},
	mounted() {
		this.getCursosCoordinadora();
		const infoCoordinadora = this.jsonCoordinadora
			? this.getInfoLogeado()
			: null;

		let menu = [
			{
				subMenu: false,
				urlTolbar: "index",
				nameToolbar: "Inicio",
			},
		];
		let titulo = "Home";

		this.updateTitulo(titulo);
		this.updateMenu(menu);
	},
	created(){

	},
	beforeDestroy(){
		if(this.currentSelector != "disponibles"){
			this.setCurrentSelector("disponibles");
			this.updateOnlyCurso(this.titulosCurso.cursosDisponibles);
		}
	}
};
</script>
<style scoped>
	
</style>
